import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import InAppCard from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/InAppCard'

import { runOnNextTick } from 'util/functions'
import styles from './styles.less'

class RecentConversationView extends React.PureComponent {
  navigate = () => {
    const { doNavigateToTicket, ticketId } = this.props
    doNavigateToTicket(ticketId)
  }

  render() {
    const { state, title, isCurrent } = this.props
    return (
      <a className="ticket" onClick={this.navigate}>
        <span className="text">{title || <em>No Subject</em>}</span>
        <span
          className={cn(`Icon`, {
            'Icon-check': state === 'closed',
            'Icon-alarm': state === 'snoozed',
          })}
        />
        {isCurrent && <span className="current-ticket-indicator" />}
      </a>
    )
  }
}

export default class RecentConversations extends React.Component {
  static contextTypes = {
    scrollerAPI: PropTypes.object,
  }

  componentDidMount() {
    this.runOnUpdate()
  }

  componentDidUpdate(prevProps) {
    const { tickets, customerId, reload } = this.props
    const changedCustomerAndNoTickets =
      prevProps.customerId !== customerId && (!tickets || tickets.length === 0)
    if (changedCustomerAndNoTickets || reload) {
      this.runSilentOnUpdate()
    }
  }

  onUpdate = () => {
    const { customerId, onUpdate } = this.props
    onUpdate(customerId)
  }

  silentOnUpdate = () => {
    const { customerId, onUpdate } = this.props
    onUpdate(customerId, { silent: true })
  }

  runOnUpdate() {
    runOnNextTick(this.onUpdate)
  }

  runSilentOnUpdate() {
    runOnNextTick(this.silentOnUpdate)
  }

  handleHideAllClick = () => {
    const { customerId, onHideAllClick } = this.props
    onHideAllClick(customerId)

    // (pnagy) if we're far from the top we restore the sidebar's scroll state with scrolling back to the top
    const { scrollerAPI } = this.context
    if (scrollerAPI) scrollerAPI.scrollToY(0)
  }

  handleShowAllClick = () => {
    const { customerId, onShowAllClick } = this.props
    onShowAllClick(customerId)
  }

  render() {
    const {
      currentTicketId,
      tickets,
      isLoading,
      isShowingAll,
      hasLoadedAll,
      doNavigateToTicket,
    } = this.props
    const ticketsToShow = isShowingAll ? tickets : tickets.slice(0, 4)
    return (
      <InAppCard title="Recent Conversations" openStateKey="recent-tickets">
        <div className={styles.recentConversations}>
          {ticketsToShow.map(ticket => {
            const isCurrent = currentTicketId === String(ticket.id)

            return (
              <RecentConversationView
                key={ticket.id}
                ticketId={ticket.id}
                title={ticket.title}
                state={ticket.state}
                isCurrent={isCurrent}
                doNavigateToTicket={doNavigateToTicket}
              />
            )
          })}
          {!isLoading &&
            (!hasLoadedAll || tickets.length > 4) && (
              <div
                className="toggle-all"
                onClick={
                  isShowingAll
                    ? this.handleHideAllClick
                    : this.handleShowAllClick
                }
              >
                {isShowingAll
                  ? 'Hide older conversations'
                  : 'See more conversations'}
              </div>
            )}
          {isLoading && (
            <div className="loading">
              <div>Loading</div>
            </div>
          )}
        </div>
      </InAppCard>
    )
  }
}
